import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=1bc51ecf&"
import script from "./Filtros.vue?vue&type=script&lang=js&"
export * from "./Filtros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports